import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { useState } from 'react';
import Logo from './Logo';
import { LINKS_EXTERNOS } from '../data/catalogoDestaque';

const WA = 'https://wa.me/5567992089769?text=' + encodeURIComponent('Olá, vim pelo site Lunins.');

const hashLink = (id: string, label: string, close: () => void) => {
  const clean = id.replace(/^#/, '');
  return (
    <Link
      to={`/#${clean}`}
      onClick={close}
      className="rounded-lg px-3 py-2 text-sm font-medium text-lunins-muted transition hover:bg-lunins-sand hover:text-lunins-ink"
    >
      {label}
    </Link>
  );
};

export default function SiteHeader() {
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);
  const close = () => setOpen(false);
  const isCassems = pathname.startsWith('/cassems');
  const logoTo = isCassems ? '/cassems' : '/';

  const navClass = (to: string) =>
    `rounded-lg px-3 py-2 text-sm font-medium transition hover:bg-lunins-sand hover:text-lunins-ink ${
      pathname === to ? 'text-lunins-ink' : 'text-lunins-muted'
    }`;
  const navClassCassems = () =>
    `rounded-lg px-3 py-2 text-sm font-medium transition hover:bg-lunins-sand hover:text-lunins-ink ${
      pathname.startsWith('/cassems') ? 'text-lunins-ink' : 'text-lunins-muted'
    }`;

  return (
    <header className="sticky top-0 z-50 border-b border-lunins-border/80 bg-lunins-cream/90 backdrop-blur-xl">
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-4 px-5 py-3.5 md:px-8 md:py-4">
        <Link to={logoTo} className="flex shrink-0 items-center gap-2 py-1" onClick={close}>
          <Logo variant="horizontal" className="h-7 w-auto md:h-8" />
        </Link>

        <nav className="hidden items-center justify-end gap-1 lg:flex">
          {isCassems ? (
            <>
              <Link to="/cassems" className={navClassCassems()}>
                Campanha
              </Link>
              <Link to="/" className={navClass('/')}>
                Site Lunins
              </Link>
            </>
          ) : (
            <>
              <Link to="/loja" className={navClass('/loja')}>
                Loja
              </Link>
              <Link to="/circuito" className={navClass('/circuito')}>
                Circuito
              </Link>
              <Link to="/salas" className={navClass('/salas')}>
                Salas
              </Link>
              <a
                href={LINKS_EXTERNOS.tutoriais}
                target="_blank"
                rel="noreferrer"
                className={navClass('/tutoriais')}
              >
                Tutoriais
              </a>
              {hashLink('comprar', 'Como comprar', close)}
            </>
          )}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href={WA}
            target="_blank"
            rel="noreferrer"
            className="hidden rounded-full bg-lunins-ink px-4 py-2 text-sm font-semibold text-lunins-cream transition hover:bg-lunins-ink-soft sm:inline-flex"
          >
            WhatsApp
          </a>
          <button
            type="button"
            className="rounded-lg p-2 text-lunins-ink lg:hidden"
            aria-label="Menu"
            onClick={() => setOpen(!open)}
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="border-t border-lunins-border bg-lunins-surface px-4 py-4 lg:hidden">
          <nav className="flex flex-col gap-1">
            {isCassems ? (
              <>
                <Link to="/cassems" onClick={close} className={navClassCassems()}>
                  Campanha Cassems
                </Link>
                <Link to="/" onClick={close} className={navClass('/')}>
                  Site Lunins
                </Link>
              </>
            ) : (
              <>
                <Link to="/" onClick={close} className={navClass('/')}>
                  Início
                </Link>
                <Link to="/loja" onClick={close} className={navClass('/loja')}>
                  Loja
                </Link>
                <a
                  href={LINKS_EXTERNOS.tutoriais}
                  target="_blank"
                  rel="noreferrer"
                  className={navClass('/tutoriais')}
                  onClick={close}
                >
                  Tutoriais
                </a>
                <Link to="/circuito" onClick={close} className={navClass('/circuito')}>
                  Circuito
                </Link>
                <Link to="/salas" onClick={close} className={navClass('/salas')}>
                  Salas
                </Link>
                {hashLink('comprar', 'Como comprar', close)}
                {hashLink('processo', 'Como atuamos', close)}
                {hashLink('organizacoes', 'Instituições', close)}
                {hashLink('compradores', 'Loja oficial', close)}
                {hashLink('depoimentos', 'Depoimentos', close)}
                <a
                  href={LINKS_EXTERNOS.instagram}
                  target="_blank"
                  rel="noreferrer"
                  className="rounded-lg px-3 py-2 text-sm font-medium text-lunins-muted"
                  onClick={close}
                >
                  Instagram @luninsbr
                </a>
              </>
            )}
          </nav>
          <a
            href={WA}
            target="_blank"
            rel="noreferrer"
            className="mt-4 block rounded-xl bg-lunins-ink py-3 text-center font-semibold text-lunins-cream"
          >
            Falar no WhatsApp
          </a>
        </div>
      )}
    </header>
  );
}
